<div class="mt-4 space-y-4">
    <div class="card">
        <form [formGroup]="form" class="space-y-4">
            <div class="w-full">
                <label class="text-sm">ช่วงเวลาข้อมูล</label>
                <app-select-date-option [selectedOption]="selectedDate"
                    (selectOption)="handleOptionSelected($event)"></app-select-date-option>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div class="w-full">
                    <label class="text-sm">สาขา</label>
                    <div class="relative w-full">
                        <input type="text" class="input" placeholder="ค้นหาสาขา"
                            [(ngModel)]="branchKeyword" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="filterBranches()" (focus)="openBranchFilter()"
                            (blur)="closeBranchFilter()">
                        <ul class="absolute z-50 w-full !rounded-lg bg-white mat-elevation-z8 max-h-72 overflow-y-auto top-11 py-2"
                            *ngIf="showBranchFilter && branchesFilter.length > 0">
                            <li *ngFor="let branch of branchesFilter"
                                class="min-h-[40px] hover:bg-secondary-100 hover:cursor-pointer flex items-center px-3 py-2 text-sm"
                                [ngClass]="{'bg-primary-50 font-semibold': branch.shop_ref === channelSelected}"
                                (mousedown)="selectBranch(branch)">
                                <span class="inline-block w-2 h-2 rounded-full mr-2 shrink-0"
                                    [style.background-color]="branch.color || '#32436a'"></span>
                                <span class="truncate">{{branch.platform_name}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="w-full md:col-span-2">
                    <label class="text-sm">สินค้า</label>
                    <div class="flex gap-2 w-full relative">
                        <input #product type="text" class="input" placeholder="SKU, ชื่อสินค้า" [(ngModel)]="keyword"
                            [ngModelOptions]="{standalone: true}" (ngModelChange)="productSearch()">
                        <ul class="absolute z-50 w-96 !rounded-lg bg-white mat-elevation-z8 max-h-72 overflow-y-auto top-11 py-2"
                            *ngIf="showProductFilter">
                            <li *ngFor="let product of productsFilter"
                                class="min-h-[48px] whitespace-nowrap hover:bg-secondary-100 hover:cursor-pointer flex items-center p-2 text-sm"
                                (click)="selectProduct(product)">
                                <img [src]="'https://storage.maxxgadget.com/img/product/' + product.sku + '/1.jpg'"
                                    alt="" class="flex-none h-11 w-11 mr-2"
                                    onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                <div class="w-full flex flex-col truncate">
                                    <span class="pr-2 text-blue-500">{{ product.sku }} :</span>
                                    <span class="w-full truncate whitespace-nowrap">{{ product.name }}</span>
                                </div>
                            </li>
                        </ul>
                        @if (keyword.length > 0) {
                        <div class="absolute flex justify-center flex-col right-2 top-1">
                            <button (click)="clearSearch()">
                                <fa-icon [icon]="faXmark" class="text-secondary-900"></fa-icon>
                            </button>
                        </div>
                        }
                    </div>
                </div>
                <button class="btn-sm btn-primary w-full md:w-fit self-end" [disabled]="loading"
                    (click)="submitForm()">ค้นหา</button>
            </div>
        </form>
        <div class="mt-4 w-full bg-gray-100 rounded-lg p-4 text-sm">
            <div class="flex gap-4">
                <div class="whitespace-nowrap text-gray-500">สินค้าที่เลือก : </div>
                @if(productSelected.length>0){
                <div class="w-full flex flex-row gap-1 flex-wrap">
                    @for (item of productSelected; track $index) {
                    <div class="label label-primary w-fit !text-xs text-nowrap">
                        {{item.name}}
                        <span class="cursor-pointer ml-3" (click)="removeProductSelected(item)">&#x2715;</span>
                    </div>
                    }
                    @if(productSelected.length>1){
                    <button class="label label-light w-fit !text-xs text-nowrap border" type="button"
                        (click)="removeProductSelectedAll()">ลบทั้งหมด</button>
                    }
                </div>
                }@else {
                ทั้งหมด
                }
            </div>
        </div>
    </div>

    @if(loading){
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <app-loader></app-loader>
            <div class="font-medium">Loading</div>
        </div>
    </div>
    }
    @if (!loading && rows.length === 0) {
    <div class="card">
        <div class="flex flex-col items-center py-6 space-y-3">
            <div class="h-32">
                <img src="assets/images/web_20.png" alt="" class="h-full">
            </div>
            <div class="font-medium">Data Not Found</div>
        </div>
    </div>
    }
    @else if (!loading && rows.length > 0){
    <div class="card">
        <div class="div-table">
            <div class="overflow-auto">
                <table class="min-w-full">
                    <thead>
                        <tr class="thead-tr">
                            <th class="text-left">สินค้า</th>
                            <th class="text-left">สาขา</th>
                            <th class="text-right">
                                <button class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                    (click)="sortBy('branch_stock')">
                                    <span>สต๊อกสาขา</span>
                                    @if (sortField==='branch_stock') {
                                    <fa-icon [icon]="sortDir==='asc' ? faCaretUp : faCaretDown"
                                        class="text-primary-500"></fa-icon>
                                    } @else {
                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                    }
                                </button>
                            </th>
                            <th class="text-right">
                                <button class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                    (click)="sortBy('hq_stock')">
                                    <span>สต๊อกสำนักงาน</span>
                                    @if (sortField==='hq_stock') {
                                    <fa-icon [icon]="sortDir==='asc' ? faCaretUp : faCaretDown"
                                        class="text-primary-500"></fa-icon>
                                    } @else {
                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                    }
                                </button>
                            </th>
                            <th class="text-right">
                                <button class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                    (click)="sortBy('total_qty')">
                                    <span>ยอดขายรวม</span>
                                    @if (sortField==='total_qty') {
                                    <fa-icon [icon]="sortDir==='asc' ? faCaretUp : faCaretDown"
                                        class="text-primary-500"></fa-icon>
                                    } @else {
                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                    }
                                </button>
                            </th>
                            <th class="text-right">
                                <button class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                    (click)="sortBy('avg_per_day')">
                                    <span>ยอดขายเฉลี่ย/วัน</span>
                                    @if (sortField==='avg_per_day') {
                                    <fa-icon [icon]="sortDir==='asc' ? faCaretUp : faCaretDown"
                                        class="text-primary-500"></fa-icon>
                                    } @else {
                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                    }
                                </button>
                            </th>
                            <th class="text-right">
                                <button class="w-full text-right flex flex-row space-x-1 items-center justify-end"
                                    (click)="sortBy('days_left')">
                                    <span>วันที่จะขายได้อีก</span>
                                    @if (sortField==='days_left') {
                                    <fa-icon [icon]="sortDir==='asc' ? faCaretUp : faCaretDown"
                                        class="text-primary-500"></fa-icon>
                                    } @else {
                                    <fa-icon [icon]="faSort" class="text-gray-400"></fa-icon>
                                    }
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of rows; track $index) {
                        <tr class="tbody-tr">
                            <td>
                                <div class="flex items-center gap-2">
                                    <img [src]="'https://storage.maxxgadget.com/img/product/' + row.sku + '/1.jpg'"
                                        alt="" class="w-8 h-8 shrink-0"
                                        onerror="this.onerror=null; this.src='assets/images/warranty.png'">
                                    <div class="min-w-0">
                                        <div class="text-blue-500">{{row.sku}}</div>
                                        <div class="truncate max-w-[16rem]">{{row.name}}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="whitespace-nowrap">{{row.branchName}}</td>
                            <td class="text-right"
                                [ngClass]="{'text-lime-500': row.branchStock>0, 'text-red-600': row.branchStock<=0}">
                                {{row.branchStock | number}}
                            </td>
                            <td class="text-right">{{row.hqStock | number}}</td>
                            <td class="text-right">{{row.totalQty | number}}</td>
                            <td class="text-right">{{row.avgPerDay | number}}</td>
                            <td class="text-right">
                                @if (row.daysLeft === null) {
                                <span class="text-gray-400">—</span>
                                } @else {
                                <span [ngClass]="{'text-red-600 font-semibold': row.daysLeft < 3}">{{row.daysLeft |
                                    number:'1.0-0'}}</span>
                                }
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
        <app-pagination *ngIf="countDataSource" [callBackPageChange]="callBackPageChange" [pageSize]="pageSize"
            [pageIndex]="pageIndex" [length]="countDataSource"></app-pagination>
    </div>
    }
</div>
